import Layout from "../Shared/Layout";
import BannerOurProduct from "./BannerOurProduct";
import ProductCategories from "./ProductCategories";

const OurProductsPage = ()=>{
return(
    <Layout>
        <BannerOurProduct/>
        <ProductCategories/>
    </Layout>
)
}

export default OurProductsPage ;